import executeRequest, { RequestOutput, API_GetConfig } from 'app/api'
import { Endpoint } from 'app/api/endpoints'


type CheckReturnCodeRequestParams = {
  returnCode: string
  merchantCode: string
}
type CheckReturnCodeResponse = {
  data: {
    isResoValido: boolean
  }
}
enum CheckReturnCodeReponseError {
}
export async function checkReturnCode(params: CheckReturnCodeRequestParams, config?: API_GetConfig, output?: RequestOutput<CheckReturnCodeResponse, CheckReturnCodeReponseError>) {
  executeRequest({
    endpoint: Endpoint.CheckReturnCode,
    config: config,
    params: params,
    output: output,
  })
}


type CreateReturnRequestParams = {
  returnOrder?: string
  codiceMerchant?: string
  datiUtenteReso: string
}
type CreateReturnResponse = {
  data: {
  }
}
enum CreateReturnReponseError {
}
export async function createReturn(params: CreateReturnRequestParams, config?: API_GetConfig, output?: RequestOutput<CreateReturnResponse, CreateReturnReponseError>) {
  executeRequest({
    endpoint: Endpoint.CreateReturn,
    config: config,
    params: params,
    output: output,
  })
}
